export function fetchFullGameAndCallOnNext(GamesResource, currentGame, gameId){
  GamesResource.one(gameId).get().then((game) => {
    currentGame.onNext(game);
  });

}


/** WEBPACK FOOTER **
 ** ./src/common/util/game-util.js
 **/